<template>
    <div class="charts_el" ref="chartsEl"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'GjkcH5BarCharts',

    data() {
        return {
            myChart: null,
            currentLevel: 'B' // 默认等级，可以根据需要修改
        };
    },

    mounted() {
        // this.initCharts();
    },

    methods: {
        initCharts(colorList,currentLevel,type) {
            var chartDom = this.$refs.chartsEl;
            this.myChart = echarts.init(chartDom);
            var option;

            let list = [{
                name: "D",
                value: "20"
            }, {
                name: "C",
                value: "20"
            }, {
                name: "B",
                value: "20"
            }, {
                name: "A",
                value: "20"
            }, {
                name: "A+",
                value: "20"
            }, {
                name: "__other",
                value: "0"
            }]

            let sum = 0;
            list.map((item) => {
                sum += parseInt(item.value)
            })

            list[list.length - 1].value = sum
            // let colorList = ['#F7F8FA', '#F7F8FA', '#F7F8FA', '#F7F8FA', '#F7F8FA', "rgba(0,0,0,0)"]

            option = {
                tooltip: {
                    show: false
                },
                hoverAnimation: false,
                silent: true, // 禁用鼠标事件
                color: colorList,
                graphic: {
                    elements: [{
                        type: 'text',
                        left: 'center',
                        top: '50%',
                        style: {
                            text: type=='level'?'等级评定':'得分',
                            fontSize: 12,
                            fill: '#999',
                            textAlign: 'center'
                        }
                    }, {
                        type: 'text',
                        left: 'center',
                        top: '60%',
                        style: {
                            text: currentLevel,
                            fontSize: 20,
                            fill: '#13D6AA',
                            fontWeight: 'bold',
                            textAlign: 'center'
                        }
                    }]
                },
                series: [{
                    name: "",
                    type: "pie",
                    hoverAnimation: false,
                    startAngle: -180,
                    radius: ["60%", "100%"],
                    center: ["50%", "70%"],
                    label: {
                        normal: {
                            show: true,
                            position: "inner", //显示在扇形上
                            formatter: "{b}", //显示内容
                            textStyle: {
                                color: "#fff", // 改变标示文字的颜色
                                fontSize: 16, //文字大小
                                fontWeight: "bold",
                            },
                        },
                    },
                    labelLine: {
                        normal: {
                            show: false,
                        },
                    },
                    data: list,
                    hoverOffset: 0,
                    itemStyle: {
                        borderWidth: 2,
                        borderColor: '#FFFFFF',
                    },
                },],
            }

            option && this.myChart.setOption(option);
        },
        
        // 更新等级的方法
        updateLevel(level) {
            this.currentLevel = level;
            if (this.myChart) {
                // 更新图表中的等级显示
                const option = this.myChart.getOption();
                option.graphic[1].style.text = level;
                this.myChart.setOption(option);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.charts_el {
    width: 100%;
    height: 100%;
    position: relative;
}
</style>